export const LAWN_STRIPE_GAME_WIDTH = 960
export const LAWN_STRIPE_GAME_HEIGHT = 640

export const LAWN_STRIPE_SOUND_STORAGE_KEY = 'wgis:lawn-stripe-studio:sfx-enabled'
export const LAWN_STRIPE_HAPTICS_STORAGE_KEY = 'wgis:lawn-stripe-studio:haptics-enabled'

export const LAWN_STRIPE_COLORS = {
  sky: 0xe8efcf,
  shadow: 0x36513a,
  soilDark: 0x75492f,
  soilLight: 0xa96f44,
  turfEdge: 0x315f36,
  grassUncut: 0x477e3d,
  grassLight: 0x91b956,
  grassMid: 0x75a34a,
  grassDark: 0x557f3d,
  chalk: 0xf5efcf,
  mowerYellow: 0xf2c94c,
  mowerDark: 0x173126,
  patio: 0xc9b99a,
  flower: 0xe07a5f,
  water: 0x6eb9c9,
} as const
